import { createFileRoute } from '@tanstack/react-router';
import { JourneysWizardStepHandoff } from '@/pages/workspaces/imports/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';
import { validateWizardSearch } from './-import-wizard-search';

/** The legacy importing URL. Flag off the embedded app renders; flag on it forwards to the migrated one. */
function JourneysImportImportingRoute() {
  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <JourneysWizardStepHandoff step="importing" />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/importing',
)({
  validateSearch: validateWizardSearch,
  component: JourneysImportImportingRoute,
});
